<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title>Nova reserva</v-card-title>

      <!-- Dados do usuário -->
      <v-card-text>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="client"
                  :items="clientItems"
                  :loading="isLoadingClient"
                  :search-input.sync="searchClients"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  label="Cliente"
                  prepend-icon="mdi-office-building"
                  placeholder="Digite o nome do cliente"
                  @change="searchUsersFromClient()"
                  return-object
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="user"
                  :items="users"
                  :loading="isLoadingUser"
                  :disabled="client.id == null ? true : false"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  label="Usuário"
                  prepend-icon="mdi-account"
                  placeholder="Digite o nome do usuário"
                  @change="getPromotions()"
                  return-object
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-select
                  label="Promoção"
                  v-model="promotion"
                  :items="promotions"
                  :loading="isLoadingPromotion"
                  :disabled="client.id == null ? true : false"
                  prepend-icon="mdi-gift"
                  no-data-text="Nenhuma promoção cadastrada"
                  :item-text="
                    (item) =>
                      item.promotion != undefined &&
                      item.promotion.name != undefined
                        ? item.promotion.name
                        : item.name
                  "
                  :item-value="(item) => item"
                  @change="onPromotionSelected()"
                  required
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-text>

      <!-- Datas e horários -->
      <v-card-text>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6 v-if="!clientId">
              <v-col align="start">
                <v-datetime-picker
                  label="Data e Hora do Check-in"
                  :textFieldProps="{ 'prepend-icon': 'mdi-calendar' }"
                  :timePickerProps="{ format: '24hr' }"
                  clearText="Cancelar"
                  okText="Selecionar"
                  v-model="beginDate"
                />

                <!-- <v-flex class="pr-3">
                  <span class="subheading grey--text text--darken-2">
                    Data e hora do check-in
                  </span>
                  <div class="inputs pa-1 mt-1 mb-3">
                    <datetime
                      input-id="inputDate"
                      type="datetime"
                      value-zone="America/Sao_Paulo"
                      zone="America/Sao_Paulo"
                      :minute-step="10"
                      v-model="beginDate"
                    />
                  </div>
                </v-flex> -->
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-datetime-picker
                  label="Data e Hora do Check-out"
                  :textFieldProps="{ 'prepend-icon': 'mdi-calendar' }"
                  :timePickerProps="{ format: '24hr' }"
                  :disabled="isPackage ? true : false"
                  clearText="Cancelar"
                  okText="Selecionar"
                  v-model="endDate"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6 v-if="!clientId">
              <v-col align="start">
                <v-btn
                  block
                  color="info"
                  class="mt-4 white--text"
                  @click="validateFields()"
                >
                  Buscar veículos
                </v-btn>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-text>

      <v-divider />

      <!-- Veículo -->
      <v-card-text>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6 v-if="!clientId">
              <v-col align="start">
                <v-select
                  label="Veículo"
                  no-data-text="Nenhum veículo encontrado"
                  prepend-icon="mdi-car"
                  v-model="vehicle"
                  :items="vehicles"
                  :item-text="(item) => item.brand + ' - ' + item.plate"
                  :item-value="(item) => item"
                  @change="vehicleInsuranceTax(item)"
                  required
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md8 sm6 v-if="vehicle.id">
              <v-col align="start">
                <v-row class="mt-3">
                  <v-flex xs12 md4 sm4>
                    <v-col align="start">
                      <p>Valor KM: {{ this.vehicle.price_km | formatPrice }}</p>
                    </v-col>
                  </v-flex>

                  <v-flex xs12 md4 sm4>
                    <v-col align="start">
                      <p>
                        Valor Hora: {{ this.vehicle.price_hour | formatPrice }}
                      </p>
                    </v-col>
                  </v-flex>

                  <v-flex xs12 md4 sm4>
                    <v-col align="start">
                      <p>
                        Pré-autorização:
                        {{ this.vehicle.pre_authorization_value | formatPrice }}
                      </p>
                    </v-col>
                  </v-flex>
                </v-row>
              </v-col>
            </v-flex>

            <v-flex xs12 md8 sm6 v-else>
              <v-col align="start">
                <v-row class="mt-3">
                  <v-col align="start">
                    <p>
                      Preencha os dados acima para buscar os veículos
                      disponíveis
                    </p>
                  </v-col>
                </v-row>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-text>

      <v-divider />

      <v-card-text>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-select
                  label="Cartão de Crédito"
                  no-data-text="Nenhum cartão encontrado"
                  v-model="creditCard.id"
                  :items="creditCards"
                  item-value="id"
                  item-text="nickname"
                  required
                  prepend-icon="mdi-credit-card"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-text-field
                  :disabled="promotion.id ? true : false"
                  label="Cupom de desconto"
                  v-model="cupom"
                  required
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6 v-if="!clientId">
              <v-col align="start">
                <v-btn
                  block
                  color="primary"
                  class="mt-4 white--text"
                  @click="calculateEstimative()"
                >
                  Calcular valor
                </v-btn>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-text>

      <v-divider />

      <v-card-text>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="center">
                <v-row align="center" class="mt-1">
                  <h5 class="blue--text mx-3">TOTAL:</h5>
                  <h6 class="grey--text">
                    R$
                    {{ this.total | formatPrice }}
                  </h6>
                </v-row>
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6>
              <v-col>
                <v-select
                  class="mt-0 pt-0"
                  :items="parcelamento"
                  item-text="text"
                  label="Parcelamento"
                  item-value="value"
                  no-data-text="Nenhum valor encontrado"
                  v-model="vehicleRequest.installments"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-btn
                  block
                  color="success"
                  class="mb-5 white--text"
                  @click="createReservation"
                >
                  Realizar reserva
                </v-btn>
              </v-col>
            </v-flex>

            <v-flex>
              <v-col align="start">
                <v-checkbox
                  v-if="vehicle.insurance_tax != null"
                  :label="insuranceTax"
                  color="primary"
                  hide-details
                  @change="select_insurance_tax()"
                ></v-checkbox>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import NumberHelper from './../../helpers/NumberHelper';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import Constants from '../../models/constants/Constants';

import UserController from '../../controllers/UserController.js';
import CouponController from '../../controllers/CouponController';
import VehicleController from '../../controllers/VehicleController';
import ClientController from '../../controllers/ClientController.js';
import PromotionController from '../../controllers/PromotionController';
import CreditCardController from '../../controllers/UserCreditCardController';
import PromotionUserController from '../../controllers/PromotionUserController';
import ConfigurationController from '../../controllers/ConfigurationController';
import VehicleRequestController from '../../controllers/VehicleRequestController.js';

export default {
  props: { clientId: { required: false, type: Number } },

  data() {
    return {
      blockScreen: false,
      blockScreenData: blockScreenUi.blockScreenData,
      //
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
      //
      userController: new UserController(this.$resource),
      clientController: new ClientController(this.$resource),
      couponController: new CouponController(this.$resource),
      vehicleController: new VehicleController(this.$resource),
      promotionController: new PromotionController(this.$resource),
      creditCardController: new CreditCardController(this.$resource),
      configurationController: new ConfigurationController(this.$resource),
      promotionUserController: new PromotionUserController(this.$resource),
      vehicleRequestController: new VehicleRequestController(this.$resource),

      endDate: null,
      beginDate: null,

      //
      user: {},
      users: [],
      //
      client: {},
      clients: [],
      //
      vehicle: {},
      vehicles: [],
      //
      promotion: {},
      promotions: [],
      //
      creditCard: {},
      creditCards: [],
      //
      configurations: {},
      //
      parcelamento: [],
      showInstallments: false,
      //
      cupom: '',
      vehicleRequest: {},
      isPackage: false,
      vehicleRequestEstimative: {},

      isLoadingUser: false,
      isLoadingClient: false,
      isLoadingPromotion: false,

      searchClients: null,

      insurance_paid: false,
      insuranceTax: '',
      total: null,
    };
  },

  created() {
    if (this.clientId) {
      this.client.id = this.clientId;
      this.searchUsersFromClient();
    }
  },

  computed: {
    clientItems() {
      return this.clients.map((client) => {
        return { id: client.id, name: client.name };
      });
    },

    userItems() {
      return this.users.map((user) => {
        return { id: user.id, name: user.name };
      });
    },
  },

  methods: {
    async searchUsersFromClient() {
      try {
        this.user = {};
        this.users = [];

        this.isLoadingUser = true;

        this.users = await this.userController.getUsersActiveByClientId(
          this.client.id
        );
      } catch (error) {
        return this.$awn.alert('Erro ao buscar usuários');
      } finally {
        this.isLoadingUser = false;
      }
    },

    async getPromotionsByClient() {
      this.promotions = await this.promotionController.getByClientIdFromAdm(
        this.client.id
      );
    },

    async searchPromotionsFromUser() {
      try {
        this.promotions = [];
        this.isLoadingPromotion = true;
        let response =
          await this.promotionUserController.getLastRecurrentPromotionActivationByUserId(
            this.user.id
          );

        if (
          response.promotion != undefined &&
          response.promotion.name != undefined
        ) {
          this.promotions.push(response);
        }
      } catch (error) {
        return this.$awn.alert('Erro ao obter promoções');
      } finally {
        this.isLoadingPromotion = false;
      }
    },

    async getPromotions() {
      this.promotions = [];

      await this.searchPromotionsFromUser();

      if (this.promotions.length != 0) {
        let tempoMinutos =
          await this.promotionUserController.getRecurrentTimeLeft(this.user.id);
        if (tempoMinutos == 0) {
          await this.getPromotionsByClient();
        }
      } else {
        await this.getPromotionsByClient();
      }
    },

    onPromotionSelected() {
      this.isPackage = false;
      if (this.promotion.type == 'package') this.isPackage = true;
    },

    async validateFields() {
      try {
        this.blockScreen = true;

        if (this.beginDate && this.isPackage) {
          this.endDate = moment(this.beginDate)
            .add(this.promotion.usage_time, 'm')
            .toISOString(true);
        }

        if (!this.client.id) {
          throw new Error('Cliente não selecionado');
        } else if (!this.user.id) {
          throw new Error('Usuário não selecionado');
        } else if (!this.beginDate) {
          throw new Error('Data inicial não selecionada');
        } else if (!this.endDate) {
          throw new Error('Data final não selecionada');
        }

        await this.getReservationInfos();
      } catch (error) {
        return this.$awn.alert(error.message);
      } finally {
        this.blockScreen = false;
      }
    },

    async getReservationInfos() {
      try {
        this.configurations =
          await this.configurationController.getAllConfigurationByClientId(
            this.client.id
          );

        this.vehicleRequest.begin_date = moment(this.beginDate)
          .tz('America/Sao_Paulo')
          .format();

        this.vehicleRequest.end_date = moment(this.endDate)
          .tz('America/Sao_Paulo')
          .format();

        this.vehicles = [];
        this.vehicles = await this.vehicleController.getVehiclesAvaliablesByAdm(
          this.vehicleRequest.begin_date,
          this.vehicleRequest.end_date,
          this.client.id
        );

        this.$awn.success('Veículos recuperados com sucesso');

        this.creditCards = await this.creditCardController.getAllByUserId(
          this.user.id,
          true
        );
      } catch (error) {
        return this.$awn.alert(error.message);
      }
    },

    async validateCoupon() {
      const isValidCoupon = await this.couponController.validateCoupon({
        user_id: this.user.id,
        coupon_cod: this.cupom,
      });

      if (isValidCoupon.body.status === 'true') return true;

      this.cupom = '';
      this.$awn.alert(`${isValidCoupon.body.message}`);
      return false;
    },

    // Definição da Promoção - Pacote ou Assinatura/Recorrência
    // Caso o usuário possua uma recorrência, o objeto promotion é diferente
    getPromotionId() {
      return this.promotion.promotion_id
        ? this.promotion.promotion_id
        : this.promotion.id;
    },

    async calculateEstimative() {
      let requestPreview = {
        begin_date: this.vehicleRequest.begin_date,
        end_date: this.vehicleRequest.end_date,
        vehicle_id: this.vehicle.id,
        coupon: null,
        user_id: this.user.id,
        client_id: this.client.id,
        promotion_id: null,
      };

      // Cupom
      if (this.cupom) {
        if (await this.validateCoupon()) requestPreview.coupon = this.cupom;
      }

      if (this.promotion) {
        requestPreview.promotion_id = this.getPromotionId();
      }

      try {
        this.vehicleRequestEstimative =
          await this.vehicleRequestController.getPricePreview(requestPreview);

        this.setInstallments();
      } catch (error) {
        this.$awn.alert(error.body.message);
      }

      this.insurance_paid
        ? (this.total =
            this.vehicleRequestEstimative.vehicleRequestPriceInCents +
            this.vehicle.insurance_tax)
        : (this.total =
            this.vehicleRequestEstimative.vehicleRequestPriceInCents);
    },

    setInstallments() {
      this.parcelamento = [];

      let valorTax = 0;
      let price = null;

      if (this.insurance_paid) {
        valorTax =
          this.vehicleRequestEstimative.vehicleRequestPriceInCents +
          this.vehicle.insurance_tax;
        price = parseFloat(valorTax);
      } else {
        price = parseFloat(
          this.vehicleRequestEstimative.vehicleRequestPriceInCents
        );
      }

      let max = this.configurations.max_installments.value;

      for (let i = 1; i <= max; i++) {
        let value = NumberHelper.centsToReal(price / i);
        this.parcelamento.push({ value: i, text: i + 'x de ' + value });
      }

      this.vehicleRequest.installments = this.parcelamento[0].value;
    },

    async createReservation() {
      try {
        this.blockScreen = true;

        let coupon = null;
        if (this.cupom) {
          coupon = await this.couponController.getByCode(this.cupom);
        }

        const vehicle = await this.vehicleController.getVehicleById(
          this.vehicle.id
        );

        let pre_authorization_value =
          vehicle.data.pre_authorization_value / 100;

        pre_authorization_value = pre_authorization_value.toString();

        let price_preview =
          this.vehicleRequestEstimative.vehicleRequestPriceInCents / 100;

        price_preview = price_preview.toString();

        let data = new FormData();

        data.append(
          'form',
          JSON.stringify({
            offer: null,
            price_preview,
            user_id: this.user.id,
            pre_authorization_value,
            client_id: this.client.id,
            vehicle_id: this.vehicle.id,
            card_id: this.creditCard.id,
            coupon_id: coupon ? coupon.id : null,
            coupon: this.cupom ? this.cupom : null,
            end_date: this.vehicleRequest.end_date,
            begin_date: this.vehicleRequest.begin_date,
            installments: this.vehicleRequest.installments,
            promotion_id: this.getPromotionId(),
            insurance_paid: this.insurance_paid,
          })
        );

        await this.vehicleRequestController.createByAdm(data);
        return this.$awn.success('Reserva realizada com sucesso.');
      } catch (error) {
        return this.$awn.alert(`${error.message}`);
      } finally {
        this.cleanFields();
        this.blockScreen = false;
      }
    },

    cleanFields() {
      this.endDate = '';
      this.beginDate = '';
      //
      this.user = {};
      this.users = [];
      //
      this.client = {};
      this.clients = [];
      //
      this.vehicle = {};
      this.vehicles = [];
      //
      this.promotion = {};
      this.promotions = [];
      //
      this.creditCard = {};
      this.creditCards = [];
      //
      this.configurations = {};
      //
      this.parcelamento = [];
      //
      this.vehicleRequest = {};
      //
      this.cupom = '';
      this.vehicleRequestEstimative = {};
    },
    vehicleInsuranceTax() {
      this.insuranceTax =
        'Aderir ao seguro de R$: ' +
        NumberHelper.formatPrice(this.vehicle.insurance_tax);
    },
    select_insurance_tax() {
      this.insurance_paid = !this.insurance_paid;

      this.calculateEstimative();
    },
  },

  filters: {
    formatPrice(price) {
      return NumberHelper.centsToReal(price);
    },
  },

  watch: {
    async searchClients() {
      try {
        if (this.clients.length > 0 || this.isLoadingClient) return;

        this.isLoadingClient = true;
        this.clients = await this.clientController.getAllClients();
      } catch (error) {
        return this.$awn.alert('Erro ao obter clientes');
      } finally {
        this.isLoadingClient = false;
      }
    },
  },
};
</script>

<style scoped>
.inputs {
  border: 1px solid grey;
  border-radius: 3px;
}

.inputs >>> #inputDate {
  width: 100%;
  text-align: center;
}
</style>
